import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { RouterProvider } from 'react-router/dom';

import { AuthProvider } from './auth/AuthProvider.js';
import { createQueryClient } from './lib/query-client.js';
import { router } from './routes/router.js';

/**
 * `AuthProvider` outside `QueryClientProvider` is not arbitrary: every query
 * goes through the `ApiClient` the auth context owns, so the client has to exist
 * before the first query can be issued.
 *
 * The query client is created once in state rather than at module scope - a
 * module-level client is shared across tests and leaks one test's cache into the
 * next.
 */
export function App() {
  const [queryClient] = useState(createQueryClient);

  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </AuthProvider>
  );
}
